import React from "react";
import { Form, DatePicker, Spin, Input, Radio, Space } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY, ROUTE_PLAN_TYPIES } from "../../../constants";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TextButton from "../../Buttons/TextButton";
import { getTranslation } from "../../../utils/helper";
import "./RoutePlan.scss";

const RoutePlanForm = ({
  form,
  isFetching,
  routePlan,
  handleSubmit,
  handleCancel,
  createWithOrders = false,
  createWithContacts = false,
  isDuplicate = false,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const handleOnFinish = async values => {
    const params = setParams(values);
    await handleSubmit(params);
  };

  const setParams = values => {
    const params = { ...values };
    params.deliveryDate = values.deliveryDate ? values.deliveryDate.format(DATE_FORMAT_QUERY) : null;
    return params;
  };
  let title = getTranslation(setting, "Route Plans", "New Route Plan");
  if (createWithOrders) {
    title = getTranslation(setting, "Route Plans", "Create New Route Plan with Selected Orders");
  } else if (routePlan && !isDuplicate) {
    title = getTranslation(setting, "Route Plans", "Edit Route Plan");
  } else if (createWithContacts) {
    title = getTranslation(setting, "Route Plans", "Create New Route Plan with Selected Contacts");
  } else if (routePlan && isDuplicate) {
    title = getTranslation(setting, "Route Plans", "Duplicate Route Plan") + " " + routePlan?.name || "";
  }
  return (
    <Spin spinning={isFetching}>
      <div className="GroupForm RoutePlanForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
          <div className="FormHeader">
            <div className="left">{title}</div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "Route Plans", "Route Plan Name")}
              name="name"
              rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder={getTranslation(setting, "Route Plans", "Route Plan Name")} />
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Route Plans", "Date")}
              name="deliveryDate"
              rules={[{ required: true, message: "Required" }]}>
              <DatePicker
                size="large"
                style={{ width: "100%" }}
                format={DATE_FORMAT_FRONTEND}
                placeholder={getTranslation(setting, "Route Plans", "Date")}
              />
            </Form.Item>
            {!routePlan?.type && !isDuplicate && (
              <Form.Item
                label={getTranslation(setting, "Route Plans", "Type")}
                name="type"
                rules={[{ required: true, message: "Required" }]}>
                <Radio.Group className="RoutePlanTypeRadio" disabled={createWithOrders || createWithContacts}>
                  <Space direction="vertical">
                    {ROUTE_PLAN_TYPIES.map(item => (
                      <Radio key={item.value} value={item.value}>
                        <ReactSVG className="icon" src={`/icons/${item.value.toLowerCase()}.svg`} />
                        {getTranslation(setting, "Route Plans", item.name)}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
            )}
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <TextButton label={getTranslation(setting, "Common", "Cancel")} onClick={handleCancel} />
              <PrimaryButton
                label={
                  routePlan
                    ? isDuplicate
                      ? getTranslation(setting, "Common", "Duplicate")
                      : getTranslation(setting, "Common", "Update")
                    : getTranslation(setting, "Common", "Create")
                }
                className="NewButton"
                htmlType="submit"
                icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
              />
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default RoutePlanForm;
